import BasicTable from 'components/Form/Table';
import TableWrapper from 'components/TableWrapper';
import ContainerAuthenticated from 'containers/Authenticated';
import React, { useContext } from 'react'
import { ContainerInvisible, ContainerVisible, Content, HeaderContainer, HelpTitle, SupportHeader, SupportText, SupportTitle } from './styled';
import CardsList from 'components/Form/TableCard';
import { FormSpacer, Icon, StatusContent } from 'ui/styled';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Button from 'components/Form/Button';
import { CoreContext } from 'context/CoreContext';
import { useMemo, useState } from 'react';
import useList from 'hooks/useList';
import useI18n from 'hooks/useI18n';
import moment from 'moment/moment';

export default function Support() {
  const history = useHistory();
  const navigate = to => history.push(`/${to}`);

  const { user, setModal } = useContext(CoreContext)
  const { registers, loading, init } = useList({ table: `supports`, query: `?filters[user]=${user?.id}` })

  const { t } = useI18n()

  const rows = useMemo(() => [
    ...(registers || [])?.map(m => ({
      ...m,
      ticket: m?.id,
      createdDate: moment(m?.createdAt)?.format("L"),
      subject: m?.title,
      lastUpdated: moment(m?.updatedAt)?.format("L"),
      category: m?.industry,
      status: m?.status,
    }))
  ], [registers]);


  const columns = useMemo(() => [
    { title: t('ticket_id'), ref: 'ticket' },
    { title: t('created_date'), ref: 'createdDate' },
    { title: t('subject_title'), ref: 'subject' },
    { title: t('last_updated'), ref: 'lastUpdated' },
    { title: t('category_department'), ref: 'category' },
    {
      title: t('status'), ref: 'status', renderCell: ({ row }) =>
        <><StatusContent color={row?.status}>{row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1).toLowerCase()}</StatusContent></>
    },
    {
      title: '', ref: 'action', renderCell: ({ row }) =>
        <Icon icon="chevron-left" pointer nomargin onClick={() => navigate(`support/${row?.id}`)} />
    },
  ].filter(f => f), [t, navigate])

  const options = useMemo(() => [
    { title: t("all_tickets"), type: 'all' },
    { title: t("pending"), type: 'pending' },
    { title: t("closed_tickets"), type: 'closed' },
  ], [t])

  const [activeOptions, setActiveOptions] = useState(options?.[0]?.type)

  const filterType = item => {
    return !activeOptions || activeOptions === 'all' || (
      item?.status === activeOptions
    )
  }

  return (
    <>
      <FormSpacer extraLarge />

      <Content>
        <SupportHeader>
          <HeaderContainer>
            <SupportTitle>{t("how_can_we_help_you")}</SupportTitle>
            {/* <SupportText>{t("help_you_text")}</SupportText> */}
            <SupportText>
              This <strong>space is for submitting requests related to the materials, content, and functionality of the MagVenture Universe platform.</strong> <br /> For support related to MagVenture equipment or service inquiries, please use the Contact Us form in the left-hand menu or reach out directly to your local representative via email.
            </SupportText>
            <HelpTitle>{t("support")}</HelpTitle>
          </HeaderContainer>
          <Button outline color='primary' width={'fit-content'} startIcon={<Icon icon="plus" />} onClick={() => setModal({ type: 'newticket', reload: () => init() })}>
            {t("add_new_ticket")}
          </Button>
        </SupportHeader>
        <TableWrapper nosearch options={options} activeOptions={activeOptions} setActiveOptions={setActiveOptions}>
          {/* <ContainerInvisible> */}
          <BasicTable loading={loading} columns={columns} rows={rows?.filter(filterType)} pagination />
          {/* </ContainerInvisible> */}
          {/* <ContainerVisible><CardsList columns={columns} rows={rows} pagination /></ContainerVisible> */}
        </TableWrapper>
      </Content>
    </>

  )
}
